import engineering from "../../assets/icons/JobIcons/icon_engineering.png";
import banking from "../../assets/icons/JobIcons/icon_banking.png";
import state_gov from "../../assets/icons/JobIcons/icon_gov.png";
import teaching from "../../assets/icons/JobIcons/icon_teaching.png";
import technology from "../../assets/icons/JobIcons/icon_technology.png";
import railway from "../../assets/icons/JobIcons/icon_railway.png";
import defence from "../../assets/icons/JobIcons/icon_defence.png";
import accounts from "../../assets/icons/JobIcons/icon_acc.png";
import central_gov from "../../assets/icons/JobIcons/icon_gov.png";
import gpsc from "../../assets/icons/JobIcons/icon_gpsc.png";
import police from "../../assets/icons/JobIcons/icon_police.png";
import upsc from "../../assets/icons/JobIcons/icon_upsc.png";
import hr from "../../assets/icons/JobIcons/icon_hr.png";
import sales from "../../assets/icons/JobIcons/icon_sales.png";
import marketing from "../../assets/icons/JobIcons/icon_marketing.png";
import finance from "../../assets/icons/JobIcons/icon_finance.png";
import operations from "../../assets/icons/JobIcons/icon_operations.png";
import customer_service from "../../assets/icons/JobIcons/icon_customer_service.png";
import embedded from "../../assets/icons/JobIcons/icon_embedded.png";
import ai_ml from "../../assets/icons/JobIcons/icon_ai_ml.png";
export const CURRENT_AFFAIRS_ITEMS_PER_PAGE = 6;

export const getDefaultImage = (id: any) => {
  switch (+id) {
    case 1:
      return engineering;
    case 2:
      return banking;
    case 3:
      return state_gov;
    case 4:
      return teaching;
    case 5:
      return technology;
    case 6:
      return railway;
    case 7:
      return defence;
    case 8:
      return central_gov;
    case 9:
      return accounts;
    case 10:
      return gpsc;
    case 11:
      return police;
    case 12:
      return upsc;
    case 13:
      return hr;
    case 14:
      return sales;
    case 15:
      return marketing;
    case 16:
      return finance;
    case 17:
      return operations;
    case 18:
      return customer_service;
    case 19:
      return embedded;
    case 20:
      return ai_ml;
    default:
      return hr;
  }
};

export const getFirstLetterCapital = (sentence: string = "") => {
  const words = (sentence || "").trim().toLowerCase().split(" ");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i]?.length
      ? words[i][0].toUpperCase() + words[i].substring(1)
      : words[i];
  }

  return words.join(" ");
};

export const getFullURLPath = () => {
  return typeof window !== "undefined" && window.location.href
    ? window.location.href
    : "";
};

export const getSharingTextForJobs = (url: string) => {
  return `Find more Job Openings on Freshment  and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this position - ${url}`;
};

export const getSharingCurrentAffairText = (url: string) => {
  return `Find Daily Current Affairs on Freshment  and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this news today - ${url}`;
};

export const getShareMsgGovtJobpaperSyllabus = (url: string) => {
  return `Stay Updated with Freshment on Govt Exam Syllabus and Papers and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this Material today - ${url}`;
};

export const getShareMsgEbook = (url: string) => {
  return `Stay Updated with Freshment on Getting New E-Books and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this Material today - ${url}`;
};

export const getShareMsgPlacementPaper = (url: string) => {
  return `Let's prepare for placement with latest placement papers on Freshment and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this Placement Papers today - ${url}`;
};

export const getShareMsgGK = (url: string) => {
  return `Stay Updated with Freshment on Daily GK Events and Be a Part of 50,000+ Candidates Growing Network \n\n Download App Today https://play.google.com/store/apps/details?id=com.govtjobs.naukari \n\n Be a helping hand to your friends. Share this Material today - ${url}`;
};

export const deepCopyJSON = (jsonData) => {
  return JSON.parse(JSON.stringify(jsonData));
};
